// import React from "react";
// import "./ExpenseTable.scss";

// const ExpenseTable = ({ data }) => {
//   // Sample data

//   const maxExpense = Math.max(...data.map((item) => item.expenses));

//   return (
//     <div className="expense-table-container">
//       {/* Header Row */}
//       {/* <div className="table-header">
//         <div className="header-cell department-header">Department</div>
//         <div className="header-cell expense-header">Total Expenses</div>
//       </div> */}

//       {/* Data Rows */}
//       {data.map((item, index) => {
//         const intensity = (item.expenses / maxExpense) * 100;

//         return (
//           <div key={index} className="table-row">
//             <div className="table-cell department-cell">{item.department}</div>
//             <div className="expense-cell">
//               <div
//                 className="expense-cell-item"
//                 style={{
//                   width: `${intensity}%`,
//                   backgroundColor: `${
//                     intensity > 0 ? "#FFDAB9" : "rgb(235, 235, 235)"
//                   }`,
//                 }}
//               >
//                 <p>
//                   {new Intl.NumberFormat("en-US", {
//                     style: "currency",
//                     currency: "USD",
//                   }).format(item.expenses)}
//                 </p>
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default ExpenseTable;


import React from "react";
import "./ExpenseTable.scss";
import { toMillionFormat } from "../../../utils/format"

const ExpenseTable = ({ data }) => {
  // Handle multiple possible expense fields gracefully
  const getExpenseValue = (item) => {
    if (item.expenses !== undefined && item.expenses !== null) return item.expenses;
    if (item.total_expenses !== undefined && item.total_expenses !== null)
      return item.total_expenses;
    if (item.account_dashboard_rename && !isNaN(item.account_dashboard_rename))
      return Number(item.account_dashboard_rename);
    return 0; // fallback
  };

  const maxExpense = Math.max(...data.map((item) => getExpenseValue(item)));

  return (
    <div className="expense-table-container">
      {data.map((item, index) => {
        const expenseValue = getExpenseValue(item);
        const intensity = maxExpense > 0 ? (expenseValue / maxExpense) * 100 : 0;

        return (
          <div key={index} className="table-row">
            <div className="table-cell department-cell">
              {item.department || item.account_dashboard_rename || "Unknown"}
            </div>

            <div className="expense-cell">
              <div
                className="expense-cell-item"
                style={{
                  width: `${intensity}%`,
                  backgroundColor: intensity > 0 ? "#ffc7b9ff" : "rgb(235, 235, 235)",
                }}
              >
                <p>
                  {toMillionFormat(expenseValue)}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ExpenseTable;

